import { ACTION_ENDED_EVENT, ACTION_FAILED_EVENT, ACTION_SUCCESS_EVENT, SUBMIT_SUCCESS_EVENT } from "../../../constants/custom-event-names"

/**
 * @memberof usePendingStatus
 * */
export const PendingStatusEventTriggers = {
    SUBMIT_SUCCESS: SUBMIT_SUCCESS_EVENT,
    ACTION_FAILED: ACTION_FAILED_EVENT,
    ACTION_SUCCESS: ACTION_SUCCESS_EVENT,
    ACTION_ENDED: ACTION_ENDED_EVENT,
} as const

/**
 * @memberof usePendingStatus
 * */
export type PendingStatusEventTriggers = (typeof PendingStatusEventTriggers)[keyof typeof PendingStatusEventTriggers]
